/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
==========================================================================================*/


export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  //   i18n: "Email",
  // },
  {
    url: '/dashboard',
    name: "Dashboard",
    slug: "dashboard",
    icon: "HomeIcon",
    i18n: "Dashboard",
  },
  {
    url: '/calendar',
    name: "Calendar",
    slug: "calendar",
    icon: "CalendarIcon",
    i18n: "Calendar",
  },
  {
    url: "/chat",
    tag: null,
    tagColor: 'primary',
    name: "Chat",
    slug: "chat",
    icon: "MessageSquareIcon",
    i18n: "Chat",
  },
  {
    url: null,
    name: "Packages",
    icon: "ArchiveIcon",
    i18n: "Packages",
    submenu: [
      {
        url: '/packages/add',
        name: "Add Module",
        slug: "packages-add",
        i18n: "AddPackages",
      },
      {
        url: '/packages',
        name: "All Packages",
        slug: "packages-list",
        i18n: "AllPackages",
      },
    ]
  },
  {
    url: null,
    name: "Modules",
    icon: "FileIcon",
    i18n: "Modules",
    submenu: [
      {
        url: '/modules/add',
        name: "Add Module",
        slug: "modules-add",
        i18n: "AddModule",
      },
      {
        url: '/modules',
        name: "All Modules",
        slug: "modules-list",
        i18n: "AllModules",
      },
    ]
  },
  {
    url: null,
    name: "Teachers",
    icon: "UserIcon",
    i18n: "Teachers",
    submenu: [
      {
        url: '/teachers',
        name: "All Teachers",
        slug: "teachers-list",
        i18n: "AllTeachers",
      },
      {
        url: '/teachers/add',
        name: "Add Teacher",
        slug: "teachers-add",
        i18n: "AddTeacher",
      },
    ]
  },
  {
    url: null,
    name: "Students",
    icon: "UsersIcon",
    i18n: "Students",
    submenu: [
      {
        url: '/students',
        name: "All Students",
        slug: "students-list",
        i18n: "AllStudents",
      },
      {
        url: '/students/add',
        name: "Add Student",
        slug: "students-add",
        i18n: "AddStudent",
      },
    ]
  },
  // {
  //   url: '/subscription',
  //   slug: 'subscription',
  //   name: "Subscription",
  //   icon: "DollarSignIcon",
  //   i18n: "Subscription",
  // },
  {
    url: '/settings',
    slug: 'settings',
    name: "Settings",
    icon: "SettingsIcon",
    i18n: "Settings",
  },
]

